<template>
  <section id="patient-case-information-view" class="case-creation" v-loading="loading">
    <div class="case-creation__step case-creation__patient-information">
      <div class="case-creation__card">
        <div v-if="!caseForm && !isEdit">
          <el-button class="edit-btn" v-if="!isOrderCompleted && hasPermission('emr_orders', 'edit')"
            :title="editButtonTitle" :class="{ 'cursor-disabled': isOrderCompleted }" @click="caseFormView"
            :disabled="accessionDisableCreated">
            <span class="edit-icon">
              <img src="@/assets/images/icons/edit-case-information.svg" alt="" />

              EDIT
            </span>
          </el-button>
        </div>

        <div v-if="caseForm || isEdit">
          <div class="vue-form">
            <div class="case-creation__heading">
              <div class="title-with-icon">
                <span class="icon">
                  <img src="@/assets/images/icons/icon-patient-info.svg" alt="icon" class="img-fluid" />
                </span>
                <h3 class="title">Patient Information</h3>
                <div v-if="this?.getSingleEMROrder && getSingleEMROrder?.is_stat"></div>
              </div>
            </div>
            <PatientInformation v-if="showDob" :patientInfo="patientInformation" ref="patientInformationForm">
            </PatientInformation>
            <el-form :model="caseInformationFormData">
              <div class="case-creation__heading mt-15">
                <div class="title-with-icon">
                  <span class="icon">
                    <img src="@/assets/images/icons/icon-case-info.svg" alt="icon" class="img-fluid" />
                  </span>
                  <h3 class="title">Case Information</h3>
                </div>
              </div>
              <div class="case-creation__body mb-15">
                <el-row :gutter="30">
                  <div style="display: flex; flex-direction: column;">
                  <div style="display: flex;  gap: 12px; font-family: sans-serif; ">
                    <div>
                      <p style="margin: 0; font-weight: 500;   ">STAT Case</p>
                    </div>
                    <div>
                        <label
                      style="position: relative; display: inline-block; width: 50px; height: 28px;"
                    >
                      <input
                        type="checkbox"
                        v-model="caseInformationFormData.is_stat"
                        style="opacity: 0; width: 0; height: 0;"
                      />
                      <span
                        :style="`
                          position: absolute;
                          cursor: pointer;
                          top: 0;
                          left: 0;
                          right: 0;
                          bottom: 0;
                          height: 20px;
                          width: 36px;
                          background-color: ${caseInformationFormData.is_stat ? '#4ade80' : '#f2f2f2'};
                          border : ${caseInformationFormData.is_stat ? '#4ade80' : '#f2f2f2'};
                          border-radius: 34px;
                          transition: 0.4s;
                          display: flex;
                          align-items: center;
                          padding: 0 4px;
                        `"
                      >
                        <span
                          :style="`
                            height: 20px;
                            width: 20px;
                            background-color: ${caseInformationFormData.is_stat ? '#f2f2f2' : 'white'};
                            border-radius: 50%;
                            transition: 0.4s;
                            transform: translateX(${caseInformationFormData.is_stat ? '22px' : '0'});
                          `"
                        ></span>
                      </span>
                    </label>
                      </div>
                  </div>
                  <div style="margin-bottom: 20px">
                    <small style="height: 12px; opacity: 50%"
                      >(only for emergency cases)</small>
                  </div>
                </div>
                  <el-col :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">
                          Case Type
                          <span class="star">*</span>
                        </label>
                        <el-select v-model="caseInformationFormData.case_types" placeholder="Select Case Type" multiple
                          collapse-tags :multiple-limit="getCaseTypeLimit" filterable @change="addSpecimenCaseTypes">
                          <el-option v-for="(caseType, index) of getCaseTypes" :key="index" :value="caseType.value"
                            :label="caseType.case_name" :disabled="checkCaseTypeDisable(caseType)"></el-option>
                        </el-select>
                        <p class="err" v-if="
                          getCaseCreationValidationErrors &&
                          getCaseCreationValidationErrors.case_types
                        ">
                          {{ getCaseCreationValidationErrors.case_types }}
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">
                          Laboratory
                          <span class="star">*</span>
                        </label>
                        <el-select v-model="caseInformationFormData.lab" placeholder="Select Lab">
                          <el-option v-for="(lab, index) of getAllLabs" :key="index" :value="lab._id"
                            :label="lab.name"></el-option>
                        </el-select>
                        <p class="err" v-if="
                          getCaseCreationValidationErrors &&
                          getCaseCreationValidationErrors.lab
                        ">
                          {{ getCaseCreationValidationErrors.lab }}
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>

                  <el-col :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">
                          Collection Date & Time
                          <span class="star">*</span>
                        </label>
                        <el-date-picker type="datetime" v-model="caseInformationFormData.collection_date"
                          placeholder="MM-DD-YYYY HH:MM AM" format="MM-DD-YYYY hh:mm A" @focus="checkDateValue"
                          :disabled-date="disabledDate" :default-time="defaultTime"></el-date-picker>

                        <p class="err" v-if="
                          getCaseCreationValidationErrors &&
                          getCaseCreationValidationErrors.collection_date
                        ">
                          {{ getCaseCreationValidationErrors.collection_date }}
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">
                          Received Date & Time
                          <span class="star">*</span>
                        </label>
                        <el-date-picker type="datetime" v-model="caseInformationFormData.received_date"
                          placeholder="MM-DD-YYYY HH:MM AM" format="MM-DD-YYYY hh:mm A" @focus="checkDateValue"
                          :disabled-date="disabledDate" :default-time="defaultTime"></el-date-picker>

                        <p class="err" v-if="
                          getCaseCreationValidationErrors &&
                          getCaseCreationValidationErrors.received_date
                        ">
                          {{ getCaseCreationValidationErrors.received_date }}
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>

                  <el-col :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">
                          Ordering Facility
                          <span class="star">*</span>
                        </label>
                        <el-select v-model="caseInformationFormData.hospital" placeholder="Select Ordering Facility"
                          @change="fetchAllPhysiciansByHospital" :filterable="true" clearable>
                          <el-option v-for="(hospital, index) of hospitalsData.data" :key="index" :value="hospital._id"
                            :label="hospital.name"></el-option>
                        </el-select>
                        <p class="err" v-if="
                          getCaseCreationValidationErrors &&
                          getCaseCreationValidationErrors.hospital
                        ">
                          {{ getCaseCreationValidationErrors.hospital }}
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">Ordering Facility Branch</label>
                        <el-select v-model="caseInformationFormData.hospital_branch"
                          placeholder="Select Ordering Facility Branch" :filterable="true"
                          @change="fetchAllPhysiciansByHospitalBranch" :clearable="true">
                          <el-option v-for="(hospital, index) of hopitalBranches" :key="index" :value="hospital._id"
                            :label="hospital.display_name"></el-option>
                        </el-select>
                        <p class="err" v-if="
                          getCaseCreationValidationErrors &&
                          getCaseCreationValidationErrors.hospital_branch
                        ">
                          {{ getCaseCreationValidationErrors.hospital_branch }}
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">
                          Ordering Physician
                          <span class="star">*</span>
                        </label>
                        <el-select v-model="caseInformationFormData.ordering_physician"
                          placeholder="Select Ordering Physician" filterable>
                          <el-option v-for="(physician, index) of physiciansData.data" :key="index"
                            :label="physician.name" :value="physician._id"></el-option>
                        </el-select>
                        <p class="err" v-if="
                          getCaseCreationValidationErrors &&
                          getCaseCreationValidationErrors.ordering_physician
                        ">
                          {{
                            getCaseCreationValidationErrors.ordering_physician
                          }}
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>

                  <el-col :xl="12" :lg="20">
                    <div class="case-creation__input">
                      <el-form-item>
                        <div style="
                            display: flex;
                            align-items: center;
                            column-gap: 2rem;
                          ">
                          <label for="text">
                            ICD-10 ( Indicative )
                            <span class="star">*</span>
                          </label>
                          <el-checkbox class="el-checkbox-icd" style="
                              display: flex;
                              align-items: center;
                              height: 14px;
                            " v-model="includeAllICDCodes">Include All ICD Codes</el-checkbox>
                        </div>

                        <div class="ten-icd-group d-flex">
                          <div class="each-input mr-5" v-for="(
icdCode, index
                            ) of caseInformationFormData.icd_10_codesForm" :key="index">
                            <el-autocomplete placeholder="CODE" v-model="icdCode.value" popper-class="ten-icd-popper"
                              :fetch-suggestions="getAutoCompleteICDData" @select="selectICDCode($event, icdCode)">
                              <template #default="{ item }">
                                <div class="icd-dropdown-style">
                                  <span class="code pr-5">{{ item.code }}</span>
                                  <span class="desc pl-5">{{
                                    item.description
                                  }}</span>
                                </div>
                              </template>
                            </el-autocomplete>
                          </div>
                        </div>
                        <p class="err">
                          <FormError errorName="icd_10_codes"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <div class="case-creation__input">
                      <el-form-item>
                        <BillingTypesDropdown :billData="caseInformationFormData"
                          :validataionErrors="getCaseCreationValidationErrors" errorKey="billing_type">
                        </BillingTypesDropdown>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="8" :lg="10" :md="3" :sm="6" :xs="6" v-if="
                    caseInformationFormData.case_types &&
                    caseInformationFormData.case_types.length == 1
                  ">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">Specimen Types <span class="star">*</span></label>

                        <div class="specimen-case-type" v-for="(type, index) in this.caseInformationFormData
                          .sample_types" :key="index">
                          <span class="case-name">{{
                            caseTypeMap[type.case_type]
                          }}</span>
                          <span class="custom-select-capitalize">
                            <el-select v-model="type.sample_types" multiple filterable allow-create
                              :reserve-keyword="false" default-first-option popper-class="custom-select-dropdown">
                              <el-option v-for="(specimen, index) in getSpecimenTypes[
                                type.case_type
                              ]" :key="index" :label="specimen" :value="specimen"></el-option>
                            </el-select>
                            <p class="err">
                              <FormError :errorName="`sample_types.${index}.sample_types`"></FormError>
                            </p>
                          </span>
                        </div>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <!-- ! Billing Information || Case Creation -->

                <el-row v-if="
                  getCaseCreationValidationErrors &&
                  getCaseCreationValidationErrors.tests_info
                ">
                  <p class="err">
                    {{ getCaseCreationValidationErrors.tests_info }}
                  </p>
                </el-row>
                <el-row v-if="
                  getCaseCreationValidationErrors &&
                  getCaseCreationValidationErrors.critical_error
                ">
                  <p class="err">
                    {{ getCaseCreationValidationErrors.critical_error }}
                  </p>
                </el-row>
                <el-row v-else-if="
                  getCaseCreationValidationErrorsCode &&
                  getCaseCreationValidationErrorsCode.error_code ===
                  'GENETIC_VALIDATE'
                ">
                  <el-col :span="24">
                    <p class="err">
                      {{ getCaseCreationValidationErrorsCode.message }}
                    </p>
                  </el-col>
                </el-row>
              </div>
              <div class="case-creation__step case-creation__billing-information"
                v-if="caseInformationFormData.billing_type == 'INSURANCE'">
                <div class="case-creation__heading justify-start">
                  <div class="title-with-icon">
                    <span class="icon">
                      <img src="@/assets/images/icons/icon-billing-info.svg" alt="icon" class="img-fluid" />
                    </span>
                    <h3 class="title">Billing Information</h3>
                  </div>
                  <div class="billing_alignmens">
                    <p class="err">
                      <FormError errorName="billing_info"></FormError>
                    </p>
                  </div>
                </div>
                <div class="case-creation__billing-information__body">
                  <div class="case-creation__tabs billing-information-tabs">
                    <el-tabs v-model="activeName" @tab-click="updateSelectedTabQuery">
                      <el-tab-pane name="first">
                        <template #label>
                          <span class="inactive-tabs" :class="{ 'active-tabs': hasError }">primary insurance</span>
                        </template>
                        <PrimaryInsurance v-if="activeName === 'first'" :primaryInsurance="primaryInsuranceForm"
                          :refreshDob="refreshPatientDob" :parentRefs="$refs" ref="primaryInsuranceForm">
                        </PrimaryInsurance>
                      </el-tab-pane>
                      <el-tab-pane name="second">
                        <template #label>
                          <span class="inactive-tabs" :class="{ 'active-tabs': hasSecondaryErrors }">Secondary
                            Insurance</span>
                        </template>
                        <SecondaryInsurance v-if="activeName === 'second'" :secondaryInsurance="secondaryInsuranceForm"
                          ref="secondaryInsuranceForm" :parentRefs="$refs" :refreshDob="true"></SecondaryInsurance>
                      </el-tab-pane>
                      <el-tab-pane name="third">
                        <template #label>
                          <span class="inactive-tabs" :class="{ 'active-tabs': hasTertiaryErrors }">Tertiary
                            Insurance</span>
                        </template>

                        <TertiaryInsuranceForm v-if="activeName === 'third'" :tertiaryInsurance="tertiaryInsuranceForm"
                          ref="tertiaryInsuranceForm" :parentRefs="$refs" :refreshDob="true"></TertiaryInsuranceForm>
                      </el-tab-pane>
                      <el-tab-pane name="fourth">
                        <template #label>
                          <span class="inactive-tabs" :class="{ 'active-tabs': hasGuarantorErrors }">Guarantor</span>
                        </template>

                        <GuarantorInsurance v-if="activeName === 'fourth'" :guarantorInsurance="guarantorInsuranceForm"
                          ref="guarantorInsuranceForm" :parentRefs="$refs"></GuarantorInsurance>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                </div>
              </div>
              <div class="case-creation__actions">
                <ul class="list">
                  <li>
                    <el-button type="button" class="btn cancel-button" @click="cancelPatientInformation">
                      Cancel
                    </el-button>
                  </li>
                  <li v-if="hasPermission('emr_orders', 'edit')">
                    <el-button type="button" class="btn save-button" @click="sumbmitPatientDetails"
                      :disabled="disablePatientInformation">
                      Update</el-button>
                  </li>
                  <li v-if="hasPermission('emr_orders', 'edit')">
                    <el-button v-if="accessionCreated" type="button" class="btn save-button"
                      @click="checkCaseTypesToCreateAccession" :disabled="disablePatientInformation">
                      Create Accession</el-button>
                  </li>
                </ul>
              </div>
            </el-form>
          </div>
        </div>
        <div class="case-view-information" v-else-if="getPatientInformation">
          <div class="case-creation__heading">
            <div class="title-with-icon">
              <span class="icon">
                <img src="@/assets/images/icons/icon-patient-info.svg" alt="icon" class="img-fluid" />
              </span>
              <h3 class="title">Patient Information</h3>
              <div v-if="this?.getSingleEMROrder && getSingleEMROrder?.is_stat">
  <span
    style="
      height: 18px;
      width: 41px;
      color: #BF1B39;
      font-weight: bold;
      padding-left: 8px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    "
  >
    STAT
  </span>
</div>            </div>
          </div>
          <div class="case-creation__body pb-0 mb-15">
            <el-row>
              <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">First Name</h4>
                  <p class="value">
                    {{
                      getPatientInformation.patient_info
                        ? convertToUppercase(getPatientInformation.patient_info.first_name)
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>

              <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Last Name</h4>
                  <p class="value">
                    {{
                      getPatientInformation.patient_info
                        ? convertToUppercase(getPatientInformation.patient_info.last_name)
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Gender</h4>
                  <p class="value">
                    {{
                      getPatientInformation.patient_info
                        ? getPatientInformation.patient_info.gender
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Date of Birth</h4>
                  <p class="value">
                    {{
                      getPatientInformation.patient_info
                        ? formatDate(
                          getPatientInformation.patient_info.date_of_birth
                        )
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">EMR #</h4>
                  <p class="value">
                    {{
                      getPatientInformation.patient_info
                        ? getPatientInformation.patient_info.emr
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>

              <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Mobile Number</h4>
                  <p class="value">
                    {{
                      getPatientInformation.patient_info
                        ? getPatientInformation.patient_info.home_phone
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Phone Number</h4>
                  <p class="value">
                    {{
                      getPatientInformation.patient_info
                        ? getPatientInformation.patient_info.work_phone
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Email</h4>
                  <p class="value">
                    {{
                      getPatientInformation.patient_info
                        ? getPatientInformation.patient_info.email
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Address Line 1</h4>
                  <p class="value">
                    {{
                      getPatientInformation.patient_info
                        ? getPatientInformation.patient_info.address_line_1
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Address Line 2</h4>
                  <p class="value">
                    {{
                      getPatientInformation.patient_info
                        ? getPatientInformation.patient_info.address_line_2
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Zip</h4>
                  <p class="value">
                    {{
                      getPatientInformation.patient_info
                        ? getPatientInformation.patient_info.zip
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>

              <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">State</h4>
                  <p class="value">
                    {{
                      getPatientInformation.patient_info
                        ? getPatientInformation.patient_info.state
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">City</h4>
                  <p class="value">
                    {{
                      getPatientInformation.patient_info
                        ? getPatientInformation.patient_info.city
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12" v-if="
                getPatientInformation.patient_info &&
                getPatientInformation.patient_info.pregnant
              ">
                <div class="input-value view-cases">
                  <h4 class="name">Pregnancy</h4>
                  <p class="value">
                    {{
                      getPatientInformation.patient_info.pregnant ? "Yes" : "No"
                    }}
                  </p>
                </div>
              </el-col>
            </el-row>
          </div>
             
          

          <div class="case-creation__heading">
            <div class="title-with-icon">
              <span class="icon">
                <img src="@/assets/images/icons/icon-case-info.svg" alt="icon" class="img-fluid" />
              </span>
              <h3 class="title">Case Information</h3>
            </div>
          </div>
          <div class="case-creation__body pb-0">
            <el-row>
              <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                <div class="input-value view-cases">
                  <h4 class="value">Case Type</h4>
                  <ul v-for="(caseType, index
                    ) of getPatientInformation.case_types" :key="index">
                    <li>{{ caseTypeMap[caseType] }}</li>
                  </ul>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
               <div class="input-value view-cases">
              <h4 class="name">STAT Case</h4>
              <p
                class="value"
                style="background: #FF0346; width: 42px ; height: 18px; border-radius: 10px; padding-left: 14px;  color: white;"
                v-if="getSingleEMROrder  && getSingleEMROrder?.is_stat"
              >
                Yes
              </p>
              <p class="value" v-else>--</p>
            </div>
          </el-col>
              <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Laboratory</h4>
                  <p class="value">
                    {{
                      getSingleEMROrder.lab ? getSingleEMROrder.lab.name : "--"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Ordering Facility</h4>
                  <p class="value" v-if="getSingleEMROrder">
                    {{
                      getPatientInformation.hospital &&
                        getPatientInformation.hospital.name
                        ? getPatientInformation.hospital.name
                        : ""
                    }}
                  </p>
                </div>
              </el-col>

              <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Ordering Facility Branch</h4>
                  <p class="value" v-if="getPatientInformation">
                    {{
                      getPatientInformation.hospital_branch
                        ? getPatientInformation.hospital_branch.display_name
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Ordering Physician</h4>
                  <p class="value" v-if="getPatientInformation">
                    {{
                      getPatientInformation.ordering_physician &&
                        getPatientInformation.ordering_physician.name
                        ? getPatientInformation.ordering_physician.name
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>

              <el-col :xl="3" :lg="4" :md="8" :sm="8" :xs="8">
                <div class="input-value">
                  <h4 class="name">Bill To</h4>
                  <p class="value">{{ getSingleEMROrder.billing_type }}</p>
                </div>
              </el-col>

              <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                <div class="input-value view-cases" v-if="getSingleEMROrder">
                  <h4 class="name">Collection Date</h4>
                  <p class="value">
                    {{
                      getSingleEMROrder.collection_date
                        ? momentWithTimezoneTime(
                          getSingleEMROrder.collection_date,
                          "MM-DD-yyyy hh:mm A"
                        )
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                <div class="input-value view-cases" v-if="getSingleEMROrder">
                  <h4 class="name">Received Date</h4>
                  <p class="value">
                    {{
                      getSingleEMROrder.received_date
                        ? momentWithTimezoneTime(
                          getSingleEMROrder.received_date,
                          "MM-DD-yyyy hh:mm A"
                        )
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="14" :lg="14" :md="12" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">ICD-10 ( Indicative )</h4>
                  <p v-if="getSingleEMROrder" class="icd-code value" v-html="getSingleEMROrder.icd_10_codes &&
                    getSingleEMROrder.icd_10_codes.length > 0
                    ? printICDCode(getSingleEMROrder.icd_10_codes)
                    : '--'
                    "></p>
                </div>
              </el-col>
              <el-col :xl="6" :lg="8" :md="12">
                <div class="input-value view-cases">
                  <div class="speciment-type-view" v-if="getSingleEMROrder && getSingleEMROrder.sample_types">
                    <div>
                      <h4 class="name">Specimen Types</h4>
                      <ul class="case_type" v-if="
                        getSingleEMROrder.sample_types &&
                        getSingleEMROrder.sample_types.length
                      ">
                        <li class="value" v-for="(
sampleType, index
                          ) in getSingleEMROrder.sample_types" :key="index">
                          <span>
                            {{ caseTypeMap[sampleType.case_type] }}
                          </span>
                        </li>
                      </ul>
                      <ul v-else>
                        --
                      </ul>
                    </div>
                    <div>
                      <h4 class="name">&nbsp;</h4>
                      <ul class="speciment_type" v-if="
                        getSingleEMROrder.sample_types &&
                        getSingleEMROrder.sample_types.length
                      ">
                        <li v-for="(
sampleType, index
                          ) in getSingleEMROrder.sample_types" :key="index">
                          <span v-if="
                            sampleType.sample_types &&
                            sampleType.sample_types.length
                          ">
                            <span v-for="(sample, index) in sampleType.sample_types" :key="index">
                              {{ sample }}
                              <span v-if="
                                index + 1 < sampleType.sample_types.length
                              ">,</span>
                            </span>
                          </span>
                          <span v-else> -- </span>
                        </li>
                      </ul>
                      <ul v-else>
                        --
                      </ul>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Order Codes</h4>
                  <ul class="order_code" v-if="
                    getSingleEMROrder &&
                    getSingleEMROrder.order_codes &&
                    getSingleEMROrder.order_codes.length
                  ">
                    <li class="totalList">
                      <div class="eachList" v-for="orderCode in getSingleEMROrder.order_codes"
                        :key="orderCode.order_code">
                        {{ orderCode.order_code }} ::
                        {{
                          orderCode.description
                        }}
                      </div>
                    </li>

                  </ul>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                <div class="input-value view-cases" v-if="getSingleEMROrder">
                  <h4 class="name">EMR Notes</h4>
                  <p class="value">
                    {{
                      getSingleEMROrder.emr_notes &&
                        getSingleEMROrder.emr_notes.length &&
                        getSingleEMROrder.emr_notes[0]
                        ? getSingleEMROrder.emr_notes[0]
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>
            </el-row>
          </div>
          <span class="case-creation__divider"></span>

          <div>
            <ErequisitionForm></ErequisitionForm>
          </div>
          <span class="case-creation__divider" v-if="hasBillingType"></span>
          <div v-if="hasBillingType">
            <BillingInformation></BillingInformation>
          </div>
        </div>
        <InsuranceEligibility v-if="insurancePopup" :insuranceEligibilityDetails="insuranceEligibilityDetails"
          :errorMessage="errorMessage" v-on:closeDialog="handleInsuranceClose" v-on:cancelCase="cancelNewCase">
        </InsuranceEligibility>
        <ExistingCaseDetails v-if="errorDiloag" v-on:closeDialog="handleClose" v-on:closePopupDialog="handlePopUp"
          :accession="convertToCase" :existedCase="existedCaseDetails" :existedCaseInfo="existingCaseData"
          :caseType="accessionCaseType" @approveCase="approveCase">
        </ExistingCaseDetails>
        <ResonForChange v-if="takeReasonDialog" v-on:close="takeReasonDialog = false" v-on:reasonSubmit="updatePatient">
        </ResonForChange>

               <!-- TEST CODES CODE -->
               <div class="default-modal">
                <el-dialog
                  v-model="multipleAccession"
                  width="30%"
                  :before-close="handlePopupClose"
                  v-loading="loading"
                  :close-on-click-modal="false"
                >
                  <div class="dialog-header">
                    <span class="header-part"
                      >Select Casetype for Accession Creation</span
                    >
                    <el-button
                      size="medium"
                      class="el-white"
                      type="info"
                      plain
                      @click="multipleAccession = false"
                    >
                      <img
                        src="@/assets/images/icons/cases/close-btn.svg"
                        alt="icon"
                      />
                    </el-button>
                  </div>
                  <div class="popup-date pb-0">
                    <div class="popup-el-select">
                      <label>Case Type*:</label>
                      <el-select
                        v-model="accessionCaseType"
                        placeholder="Select Case Type"
                        multiple
                        :multiple-limit="getCaseLimit"
                        @change="addAccessionSpecimenCaseTypes"
                      >
                        <el-option
                          v-for="(
                            caseType, index
                          ) of getSingleEMROrder.case_types"
                          :key="index"
                          :value="caseType"
                          :label="caseTypeMap[caseType]"
                          :disabled="checkCaseTypeAccesionDisable(caseType)"
                        ></el-option>
                      </el-select>
                    </div>
                    <div
                      class="popup-el-select"
                      v-if="accessionCaseType && accessionCaseType.length"
                    >
                      <label>Specimen Types*:</label>
 
                      <div
                        class="specimen-case-type"
                        v-for="(type, index) in caseInformationFormData.sample_types.filter(item => accessionCaseType.includes(item.case_type))"
                        :key="type.case_type"
                      >
                        <span class="case-name">{{
                          caseTypeMap[type.case_type]
                        }}</span>
                        <span class="custom-select-capitalize">
                          <el-select
                            v-model="type.sample_types"
                            multiple
                            filterable
                            allow-create
                            :reserve-keyword="false"
                            default-first-option
                            popper-class="custom-select-dropdown"
                          >
                            <el-option
                              v-for="(specimen, index) in getSpecimenTypes[
                                type.case_type
                              ]"
                              :key="index"
                              :label="specimen"
                              :value="specimen"
                            ></el-option>
                          </el-select>
                          <p class="err">
                            <FormError
                              :errorName="`sample_types.${index}.sample_types`"
                            ></FormError></p
                        ></span>
                      </div>
                    </div>
                    <div
                      class="popup-el-select"
                      v-if="
                        accessionCaseType &&
                        accessionCaseType.length &&
                        accessionCaseType.includes('CLINICAL_CHEMISTRY')
                      "
                    >
                      <label>Order Codes:</label>
                      <div>
                        <el-radio-group
                          v-model="selectedOption"
                          @change="handleChangeReportCategory"
                        >
                          <el-radio
                            v-for="option in categoryOptions"
                            :key="option.value"
                            :label="option.value"
                            :disabled="!isCategoryAvailable(option.value)"
                          >
                            {{ option.label }}
                          </el-radio>
                        </el-radio-group>
                      </div>
                      <div class="specimen-case-type">
                        <span class="custom-select-capitalize">
                          <el-select
                            v-model="selectedOrderCodesData"
                            multiple
                            :reserve-keyword="false"
                            default-first-option
                            popper-class="custom-select-dropdown"
                            collapse-tags >
                            <el-option
                              v-for="(code, index) in this.orderCodes"
                              :key="index"
                              :label="
                                code.category_code === 'SEND_OUTS'
                                  ? `${code.order_code} - ${code.category_code}`
                                  : code.order_code
                              "
                              :value="code.order_code"
                              :disabled="code.is_completed ||  
                              (selectedOrderCodesData.length > 0 &&
                               code.category_code !== firstSelectedCategoryCode)"
                            ></el-option>
                          </el-select>
                        </span>
                      </div>
                    </div>
                    <div class="dialog-footer">
                      <el-button class="cancel-button" @click="handlePopupClose"
                        >Cancel</el-button
                      >
                      <el-button
                        :disabled="!accessionCaseType.length"
                        class="blue-save-button"
                        @click="createAccessionNumber"
                        :loading="loading"
                        >Create Accession</el-button
                      >
                    </div>
                  </div>
                </el-dialog>
              </div>
 

        <div class="default-modal">
          <el-dialog v-model="updateCase" width="30%" :before-close="handleUpdateClose" v-loading="loading"
            :close-on-click-modal="false">
            <div class="dialog-header">
              <span class="header-part">Select Casetype for Update</span>
              <el-button size="medium" class="el-white" type="info" plain @click="updateCase = false">
                <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
              </el-button>
            </div>
            <div class="popup-date pb-0">
              <div class="popup-el-select" v-if="
                caseInformationFormData.case_types &&
                caseInformationFormData.case_types.length
              ">
                <label>Specimen Types*:</label>

                <div class="specimen-case-type" v-for="(type, index) in this.caseInformationFormData
                  .sample_types" :key="index">
                  <span class="case-name">{{
                    caseTypeMap[type.case_type]
                  }}</span>
                  <span class="custom-select-capitalize">
                    <el-select v-model="type.sample_types" multiple filterable allow-create :reserve-keyword="false"
                      default-first-option popper-class="custom-select-dropdown">
                      <el-option v-for="(specimen, index) in getSpecimenTypes[
                        type.case_type
                      ]" :key="index" :label="specimen" :value="specimen"></el-option>
                    </el-select>
                    <p class="err">
                      <FormError :errorName="`sample_types.${index}.sample_types`"></FormError>
                    </p>
                  </span>
                </div>
              </div>
              <div class="dialog-footer">
                <el-button class="cancel-button" @click="handleUpdateClose">Cancel</el-button>
                <el-button :disabled="!caseInformationFormData.sample_types" class="blue-save-button"
                  @click="updateEmrOrder">Update</el-button>
              </div>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { defineAsyncComponent } from "vue";

import { mapGetters } from "vuex";
import AppHelper from "@/mixins/AppHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import HospitalHelper from "@/mixins/HospitalHelper";
const ExistingCaseDetails = defineAsyncComponent(() =>
  import("@/components/cases/ExisistedCaseInfo")
);
import caseConstants from "@/config/constants/caseConstants";
import PatientInformation from "@/components/EMROrders/PatientInformationAdd";
import FormError from "@/components/misc/FormError";
const ResonForChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
import { startLoading } from "@/helpers/loadingHelper";
const BillingTypesDropdown = defineAsyncComponent(() =>
  import("@/components/misc/BillingTypesDropdown")
);
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import InsuranceHelper from "@/mixins/InsuranceHelper";
import PrimaryInsurance from "@/components/EMROrders/billingInfo/forms/PrimaryInsurance";
import SecondaryInsurance from "@/components/EMROrders/billingInfo/forms/SecondaryInsurance";
import TertiaryInsuranceForm from "@/components/EMROrders/billingInfo/forms/TertiaryInsurance";
import GuarantorInsurance from "@/components/EMROrders/billingInfo/forms/GuarantorInsurance";
const BillingInformation = defineAsyncComponent(() =>
  import("@/components/EMROrders/BillingInformation")
);
import orderCodes from "@/config/constants/orderCodes";

const ErequisitionForm = defineAsyncComponent(() =>
  import("@/components/EMROrders/Erequisition")
);
const InsuranceEligibility = defineAsyncComponent(() =>
  import("@/components/cases/InsuranceEligilibility")
);

export default {
  components: {
    ResonForChange,
    ExistingCaseDetails,
    BillingTypesDropdown,
    PatientInformation,
    FormError,
    PrimaryInsurance,
    SecondaryInsurance,
    TertiaryInsuranceForm,
    GuarantorInsurance,
    BillingInformation,
    ErequisitionForm,
    InsuranceEligibility,
  },
  mixins: [
    AppHelper,
    UserPermissionsHelper,
    HospitalHelper,
    caseDataHelper,
    InsuranceHelper,
  ],
  async created() {
    this.orderId = this.$route.params.order_id;
    if (this.$route.params.order_id) {
      await this.caseDetailsView();
    } else {
      this.loading = false;
      this.caseForm = true;
      this.showEditCaseInformation = false;
    }
    if (!this.$route.params.order_id) {
      return this.$router.push({
        name: "AllEMROrders",
        path: "/all-emr-orders",
      });
    }
    // getting hospitals

    this.showDob = true;

    await this.getLabCaseTypes();
    this.caseInformationFormData.lab = this.getUserPrimaryLabId;
  },
  watch: {
     selectedOrderCodesData(newVal) {
      if (newVal && newVal.length > 0) {
        const selectedCode = newVal[0];
        const matched = this.orderCodes.find(
          (code) => code.order_code === selectedCode
        );
        if (matched) {
          this.selectedOption = matched.category_code;
        }
      }else{
        this.selectedOption = '';
      }
    }
    },
  computed: {
    ...mapGetters("orders", ["getLocalPatient"]),
    ...mapGetters("cases", [
      "getAllSampleTypes",
      "getInsuranceEligibility",
      "getInsuranceDetails",
    ]),
    ...mapGetters("emrOrders", [
      "getSingleEMROrder",
      "getCaseCreationValidationErrors",
      "getOrderUpdateStatus",
      "getCaseCreationValidationErrorsCode",
      "getSingleEMRTestInfo",
      "getCreateAccessionDetails",
     "getEMRCaseTypeWiseOrderCodes"
    ]),
    ...mapGetters("auth", ["getAuthenticatedUser", "getUserPrimaryLabId"]),
    ...mapGetters("patients", ["getAllPatients"]),
    ...mapGetters("profile", ["getTestPanelsData"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("branches", ["getAllBranches"]),
    ...mapGetters("icd10Codes", ["getAllIcd10Codes"]),
    ...mapGetters("labs", ["getAllLabs"]),
    ...mapGetters("userAccounts", ["getAllUsers"]),
    CaseTypeDisable() {
      if (
        this.getSingleEMROrder &&
        this.getSingleEMROrder.accession_data &&
        this.getSingleEMROrder.accession_data.length
      ) {
        return this.getSingleEMROrder.accession_data
          .map((obj) => obj.case_type)
          .filter((type) => {
            if (type === "CLINICAL_CHEMISTRY") {
              return this.orderCodes.every(
                (order) => order.is_completed === true
              );
            }
            return true;
          });
      }
 
      return [];
    },
     firstSelectedCategoryCode() {
      const firstSelected = this.orderCodes.find(
        code => code.order_code === this.selectedOrderCodesData[0]
      );
      return firstSelected ? firstSelected.category_code : null;
    },
    getPatientInformation() {
      if (
        this.getSingleEMROrder &&
        Object.keys(this.getSingleEMROrder).length > 0 &&
        this.getSingleEMROrder
      ) {
        return this.getSingleEMROrder;
      }
      return null;
    },
    isEdit() {
      if (this.loading) {
        return false;
      }
      if (this.$route.query.edit) {
        return true;
      } else if (
        !this.getSingleEMROrder ||
        !this.getSingleEMROrder.patient_info
      ) {
        return true;
      }
      return false;
    },
    accessionCreated() {
      const order = this.getSingleEMROrder;

      if (
        order &&
        order.accession_data &&
        order.accession_data.length > 0 &&
        order.case_types 
      ){
        const accessionCaseTypes = order.accession_data.map(e => e.case_type);
        const allExist = order.case_types.every(ct => accessionCaseTypes.includes(ct));

          if (allExist) {
            return true;
          }
      }
      if (order && order.accession_id) {
        return false;
      }
      return true;
    },
    accessionDisableCreated() {
      const order = this.getSingleEMROrder;

      if (order && order.accession_id) {
        return true;
      }
      if (
        order &&
        order.accession_data &&
        order.accession_data.length > 0 &&
        order.case_types &&
        order.case_types.length > 0
      ) {
         const accessionCaseTypes = order.accession_data.map(e => e.case_type);
        const allExist = order.case_types.every(ct => accessionCaseTypes.includes(ct));

          if (allExist) {
            if (order.case_types.includes('CLINICAL_CHEMISTRY')) {
             return this.getEMRCaseTypeWiseOrderCodes.every(code => code.is_completed);
            }
            return true;
          }
      }
      if (order && order.accession_data && order.accession_data.length == 0) {
        return false;
      }
      if (order && order.case_types && order.case_types.length == 0) {
        return false;
      }
      return false;
    },

    isOrderCompleted() {
      if (!this.getSingleEMROrder) {
        return false;
      }
      const order = this.getSingleEMROrder;

        if (
        order &&
        order.accession_data &&
        order.accession_data.length > 0 &&
        order.case_types &&
        order.case_types.length > 0
      ) {
         const accessionCaseTypes = order.accession_data.map(e => e.case_type);
        const allExist = order.case_types.every(ct => accessionCaseTypes.includes(ct));

          if (allExist) {
            if (order.case_types.includes('CLINICAL_CHEMISTRY')) {
             return this.getEMRCaseTypeWiseOrderCodes.every(code => code.is_completed === true);
          }
            return true;
          }
          return false;
      }
      return this.getSingleEMROrder.status == "COMPLETED";
    },
    editButtonTitle() {
      if (this.isOrderCompleted) {
        return "Can't edit the completed order";
      }
      if (this.accessionDisableCreated) {
        return "Can't edit accession created";
      }

      return "";
    },
    getCaseTypeLimit() {
      if (
        this.caseInformationFormData.case_types &&
        this.caseInformationFormData.case_types.length &&
        this.caseInformationFormData.case_types.indexOf("COVID_FLU") != -1
      ) {
        return 2;
      }
      if (
        this.caseInformationFormData.case_types &&
        this.caseInformationFormData.case_types.length &&
        this.caseInformationFormData.case_types.indexOf("URINALYSIS") != -1
      ) {
        return 2;
      }

      return 3;
    },
    checkCaseTypeDisable() {
      return (caseType) => {
        if (
          this.caseInformationFormData.case_types &&
          this.caseInformationFormData.case_types.length &&
          this.caseInformationFormData.case_types.length == 2 &&
          this.caseInformationFormData.case_types.indexOf("COVID_FLU") == -1 &&
          caseType.value == "COVID_FLU"
        ) {
          return true;
        }
        if (
          this.caseInformationFormData.case_types &&
          this.caseInformationFormData.case_types.length &&
          this.caseInformationFormData.case_types.length == 2 &&
          this.caseInformationFormData.case_types.indexOf("URINALYSIS") == -1 &&
          caseType.value == "URINALYSIS"
        ) {
          return true;
        }
        return false;
      };
    },
    getCaseTypes() {
      return this.search_case_types;
    },
    getCaseLimit() {
      return 1;
    },

    ...mapGetters("errors", ["getErrors", "getError"]),
    hasError() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf(
              "billing_info.insurance.primary_insurance"
            ) !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    hasSecondaryErrors() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf(
              "billing_info.insurance.secondary_insurance"
            ) !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    hasTertiaryErrors() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf(
              "billing_info.insurance.tertiary_insurance"
            ) !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    hasGuarantorErrors() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf("billing_info.insurance.guarantor") !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    hasBillingType() {
      if (
        this.getSingleEMROrder &&
        this.getSingleEMROrder.billing_type &&
        this.getSingleEMROrder.billing_type == "INSURANCE"
      ) {
        return true;
      }
      return false;
    },
  },

  data() {
    return {
      showDob: false,
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      defaultTime: [new Date()],
      convertToCase: true,
      errorDiloag: false,
      existedCaseDetails: {},
      existingCaseData: {},
      caseForm: false,
      showEditCaseInformation: false,
      disablePatientInformation: false,
      orderId: "",
      loading: false,
      takeReasonDialog: false,

      panels: [],
      getSpecimenTypes: { ...caseConstants.CASE_TYPE_SPECIMEN_TYPE_MAP },

      caseInformationFormData: {
        tests_info: [],
        case_types: [],
        is_stat : false,

        collection_date: "",
        received_date: "",
        lab: "",
        hospital: "",
        hospital_branch: "",
        ordering_physician: "",
        specimen_collector: "",
        icd_10_codes: [],
        billing_type: "",
        sample_types: "",
        icd_10_codesForm: [
          {
            sno: 1,
            value: "",
          },
          {
            sno: 2,
            value: "",
          },
          {
            sno: 3,
            value: "",
          },
          {
            sno: 4,
            value: "",
          },
          {
            sno: 5,
            value: "",
          },
          {
            sno: 6,
            value: "",
          },
          {
            sno: 7,
            value: "",
          },
          {
            sno: 8,
            value: "",
          },
          {
            sno: 9,
            value: "",
          },
          {
            sno: 10,
            value: "",
          },
        ],
      },
      hopitalBranches: [],
      allLabs: [],
      patientInfo: {},
      loadDateOfBirth: false,
      patientInformation: {},
      hospitalsData: {},
      physiciansData: {},
      sampleTypesList: "",
      usersList: [],
      search_case_types: [],
      accessionCaseType: [],
      multipleAccession: false,
      testInfo: [],
      specimenTypes: [],
      coriell_test_panels: [],
      activeName: "first",
      refreshPatientDob: true,
      primaryInsuranceForm: {},
      secondaryInsuranceForm: {},
      tertiaryInsuranceForm: {},
      guarantorInsuranceForm: {},
      EMR_CODES: orderCodes.EMR_ORDER_CODES,
      includeAllICDCodes: false,
      updateCase: false,
      caseTypeToUpdate: [],
      insurancePopup: false,
      insuranceEligibilityDetails: {},
      foundCoverages: [],
      errorMessage: "",
      caseId: "",
      orderCodes:[],
      selectedOrderCodesData:[],
       selectedOption: '',
       categoryOptions: [
         { label: 'Send-Outs', value: 'SEND_OUTS' },
         { label: 'InHouse', value: 'ALL_TESTS' }
       ],
    };
  },
  async mounted(){
    if(this.getSingleEMROrder){
      if(this.getSingleEMROrder &&this.getSingleEMROrder.case_types &&
        this.getSingleEMROrder.case_types.length &&
        this.getSingleEMROrder.case_types.includes("CLINICAL_CHEMISTRY")
      ) {
        this.isClinicalChemistry()
      }
      return false
    }
  },
  methods: {
    evaluateMultipleAccession() {
      const caseTypes = this.getSingleEMROrder?.case_types;
      this.multipleAccession = !!(
        caseTypes &&
        (caseTypes.length > 1 || caseTypes.includes("CLINICAL_CHEMISTRY"))
      );
    },
    async fetchEMROrderCaseTypeWise(caseType) {
      try {
        let params = {
          emr_id: this.orderId,
          case_types: [caseType],
        };
        await this.$store.dispatch("emrOrders/fetchEMRCaseTypesCodes", params);
          console.log(this.getEMRcaseTypeWiseOrderCodes ,"getEMRcaseTypeWiseOrderCodes")
        if (this.getEMRCaseTypeWiseOrderCodes) {
          this.orderCodes = this.getEMRCaseTypeWiseOrderCodes;
        }
      } catch (err) {
        console.log(err);
      }
    },
    getOrderDescription(orderId) {
      const order = this.EMR_CODES.find((o) => o.order_code === orderId);
      return order ? order.description : orderId;
    },
    updateSelectedTabQuery() {
      const primaryInfo = this.$refs["primaryInsuranceForm"];
      if (primaryInfo) {
        this.primaryInsuranceForm = this.parseInsuranceForm(
          primaryInfo.getPrimaryInsuranceFormData()
        );
      }
      const secondaryInfo = this.$refs["secondaryInsuranceForm"];
      if (secondaryInfo) {
        this.secondaryInsuranceForm = this.parseInsuranceForm(
          secondaryInfo.getSecondaryInsuranceFormData()
        );
      }
      const teritaryInfo = this.$refs["tertiaryInsuranceForm"];
      if (teritaryInfo) {
        this.tertiaryInsuranceForm = this.parseInsuranceForm(
          teritaryInfo.getTertiaryInsuranceFormData()
        );
      }
      const gaurantorInfo = this.$refs["guarantorInsuranceForm"];
      if (gaurantorInfo) {
        this.guarantorInsuranceForm = this.parseInsuranceForm(
          gaurantorInfo.getGuarantorInsuranceFormData()
        );
      }
    },
    checkCaseTypeAccesionDisable(value) {
      return this.CaseTypeDisable.includes(value);
    },
    getLabCaseTypes() {
      if (
        this.getAuthenticatedUser &&
        this.getAuthenticatedUser.user_type == "LAB_TECHNOLOGIST"
      ) {
        this.search_case_types = this.getUserBasedCaseTypes(
          caseConstants.CASE_TYPES_DATA
        );
      } else {
        this.search_case_types = this.getLabBasedCaseTypes(
          caseConstants.CASE_TYPES_DATA
        );
      }
    },
    changetocaptila(str) {
      var splitStr = str.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(" ");
    },

    async addNewSampleType(event) {
      let sampleTypes = event;
      let data = this.getAllSampleTypes.map((a) => a.sample_type.toLowerCase());
      let difference = sampleTypes.filter(
        (x) => !data.includes(x.toLowerCase())
      );
      if (difference && difference.length) {
        let params = {
          sample_type: this.changetocaptila(difference[0]),
        };

        await this.$store.dispatch("cases/createSampleTypes", params);
        this.fetchSpecimenTypes();
      }
    },
    async fetchSpecimenTypes() {
      let params = { get_all: true };
      await this.$store.dispatch("cases/fetchAllSampleTypes", params);
    },
    addUpdateSpecimenCaseTypes() {
      if (!this.caseInformationFormData.sample_types) {
        this.caseInformationFormData.sample_types = [];
      }
      if (
        this.caseInformationFormData &&
        this.caseInformationFormData.case_types.length == 0
      ) {
        this.caseInformationFormData.sample_types = [];
      }
      if (
        this.caseInformationFormData &&
        this.caseInformationFormData.case_types &&
        this.caseInformationFormData.case_types.length
      ) {
        this.caseInformationFormData.case_types.forEach((singleCaseType) => {
          let caseSampleTypeExisted =
            this.caseInformationFormData.sample_types.find(
              (e) => e.case_type == singleCaseType
            );
          if (!caseSampleTypeExisted) {
            let defaultSampleTypes = this.getSpecimenTypes[singleCaseType];
            let caseTypeDefaultSampleName = {
              case_type: singleCaseType,
              // sample_types: [],
              sample_types:
                defaultSampleTypes.length == 1 ? defaultSampleTypes : [], // we are to add default case type here
            };
            this.caseInformationFormData.sample_types.push(
              caseTypeDefaultSampleName
            );
          }
        });

        // we need to remove not existed

        this.caseInformationFormData.sample_types =
          this.caseInformationFormData.sample_types.filter((sampleTypeData) =>
            this.caseInformationFormData.case_types.includes(
              sampleTypeData.case_type
            )
          );
      } else {
        this.caseInformationFormData.sample_types = [];
      }
    },

    addAccessionSpecimenCaseTypes() {
      if (!this.caseInformationFormData.sample_types) {
        this.caseInformationFormData.sample_types = [];
      }
      if (
        this.caseInformationFormData &&
        this.caseInformationFormData.case_types.length == 0
      ) {
        this.caseInformationFormData.sample_types = [];
      }
      if (this.accessionCaseType && this.accessionCaseType.length) {
        this.accessionCaseType.forEach((singleCaseType) => {
          let caseSampleTypeExisted =
            this.caseInformationFormData.sample_types.find(
              (e) => e.case_type == singleCaseType
            );
          if (!caseSampleTypeExisted) {
            let defaultSampleTypes = this.getSpecimenTypes[singleCaseType];
            let caseTypeDefaultSampleName = {
              case_type: singleCaseType,
              // sample_types: [],
              sample_types:
                defaultSampleTypes.length == 1 ? defaultSampleTypes : [], // we are to add default case type here
            };
            this.caseInformationFormData.sample_types.push(
              caseTypeDefaultSampleName
            );
          }
        });
 
        // we need to remove not existed
 
        this.caseInformationFormData.sample_types =
          this.caseInformationFormData.sample_types.filter((sampleTypeData) =>
            this.caseInformationFormData.case_types.includes(
              sampleTypeData.case_type
            )
          );
      } else {
        this.caseInformationFormData.sample_types = [];
      }
    },
 
    addSpecimenCaseTypes() {
      if (!this.caseInformationFormData.sample_types) {
        this.caseInformationFormData.sample_types = [];
      }
      if (
        this.caseInformationFormData &&
        this.caseInformationFormData.case_types &&
        this.caseInformationFormData.case_types.length == 0
      ) {
        this.caseInformationFormData.sample_types = [];
      }
      if (
        this.caseInformationFormData &&
        this.caseInformationFormData.case_types &&
        this.caseInformationFormData.case_types.length
      ) {
        this.caseInformationFormData.case_types.forEach((singleCaseType) => {
          let caseSampleTypeExisted =
            this.caseInformationFormData.sample_types.find(
              (e) => e.case_type == singleCaseType
            );
          if (!caseSampleTypeExisted) {
            let defaultSampleTypes = this.getSpecimenTypes[singleCaseType];
            let caseTypeDefaultSampleName = {
              case_type: singleCaseType,
              sample_types:
                defaultSampleTypes.length == 1 ? defaultSampleTypes : [],
            };
            this.caseInformationFormData.sample_types.push(
              caseTypeDefaultSampleName
            );
          }
        });

        this.caseInformationFormData.sample_types =
          this.caseInformationFormData.sample_types.filter((sampleTypeData) =>
            this.caseInformationFormData.case_types.includes(
              sampleTypeData.case_type
            )
          );
      } else {
        this.caseInformationFormData.sample_types = [];
      }
    },

    async handleClose(response) {
      this.errorDiloag = response;

      window.location.reload();
    },
    async handlePopUp(response) {
      this.errorDiloag = response;
      await this.$store.commit("errors/clear", null, { root: true });
    },

    caseDetailsView() {
      this.caseForm = false;
      this.showEditCaseInformation = true;
      this.checkCaseInformation();
    },
    async fetchEmrTestsInfo() {
      try {
        let params = {
          emr_id: this.orderId,
          case_types: this.accessionCaseType.length
            ? this.accessionCaseType
            : this.caseInformationFormData.case_types,
          lab: this.caseInformationFormData.lab
        };
        if (
          this.orderCodes?.length &&
          this.accessionCaseType?.includes("CLINICAL_CHEMISTRY")
        ) {
          params.test_codes = this.selectedOrderCodesData?.length
            ? this.selectedOrderCodesData
            : this.orderCodes.filter(e => !e.is_completed).map(e => e.order_code);
        }
        await this.$store.dispatch(
          "emrOrders/fetchSingleEMROrderTestsInfo",
          params
        );
      } catch (err) {
        if(this.getError || this.getErrors){
          console.log("this.getError",this.getError)
          console.log("this.getErrors",this.getErrors)
        }
        console.log("err: ", err);
      }
    },
 

    async fetchAllPhysiciansByHospital(hospital) {
      this.caseInformationFormData.ordering_physician = undefined;
      this.caseInformationFormData.hospital_branch = null;
      let params = {
        hospital,
        get_all: true,
      };
      await this.$store.dispatch("physicians/fetchAllPhysicians", params);
      this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
      await this.$store.dispatch("branches/fetchAllBranches", {
        hospital_id: hospital,
        get_all: true,
      });
      this.hopitalBranches = this.getAllBranches.data;
    },
    async fetchAllPhysiciansByHospitalBranch(hospitalBranch) {
      this.caseInformationFormData.ordering_physician = undefined;

      if (hospitalBranch) {
        let params = {
          hospital_branch: hospitalBranch,
          get_all: true,
        };
        await this.$store.dispatch("physicians/fetchAllPhysicians", params);
      } else {
        this.fetchAllPhysiciansByHospital(
          this.caseInformationFormData.hospital
        );
      }
    },

    checkDateValue() {
      this.$nextTick(() => {
        let pickerBodies = document.getElementsByClassName(
          "el-date-picker__editor-wrap"
        );
        for (let pickerBody of pickerBodies) {
          let inputs = pickerBody.getElementsByClassName("el-input__inner");
          for (let input of inputs) {
            input.setAttribute("readonly", "");
          }
        }
      });
    },
    async getAutoCompleteICDData(searchString, cb) {
      try {
        this.search_code = searchString.trim();

        let params = { page: 1, limit: 30 };

        if (searchString) {
          params.search_string = searchString.trim();
        }
        if (
          this.caseInformationFormData.case_types &&
          this.caseInformationFormData.case_types.length &&
          this.includeAllICDCodes == false
        ) {
          params.primary_case_types =
            this.caseInformationFormData.case_types[0];
        }
        await this.$store.dispatch("icd10Codes/fetAllIcd10Codes", params);
        const allIcdCodes = JSON.parse(JSON.stringify(this.getAllIcd10Codes));

        if (
          allIcdCodes &&
          allIcdCodes.data &&
          this.search_code === searchString
        ) {
          return cb(
            allIcdCodes.data.map((el) => {
              return {
                value: el.code,
                description: el.description,
              };
            })
          );
        } else {
          return cb([]);
        }
      } catch (err) {
        return cb([]);
      }
    },
    selectICDCode(event, icdCodeData) {
      icdCodeData.value = event.value;
      this.previousSearchString = "";
    },
    printICDCode(icd_code) {
      let formatted_icd_code = "";
      for (let i = 0; i < icd_code.length; i++) {
        formatted_icd_code += "<span> " + icd_code[i] + "</span>";
      }
      return formatted_icd_code;
    },

    async cancelPatientInformation() {
      await this.$store.commit("errors/clear", null, { root: true });
      await this.$store.commit(
        "emrOrders/setCaseCreationValidationErrors",
        null,
        {
          root: true,
        }
      );

      if (!this.orderId) {
        this.$router.push({
          name: "Patient-Information",
          params: this.$route.params,
          query: this.$route.query,
        });
      } else {
        this.caseForm = false;
        this.showEditCaseInformation = true;
        this.loadDateOfBirth = false;
        await this.$store.dispatch("emrOrders/fetchSingleEMROrder", {
          order_id: this.orderId,
        });
        this.setCaseInformationData();
      }
    },
    async handleChangeReportCategory(value) {
         if (value === 'SEND_OUTS') {
           this.selectedOrderCodesData = this.orderCodes
             .filter((obj) => obj.category_code === value &&  obj.is_completed !== true)
             .map((obj) => obj.order_code);
         } else {
           this.selectedOrderCodesData = this.orderCodes
             .filter((obj) => obj.category_code !== 'SEND_OUTS' &&  obj.is_completed !== true)
             .map((obj) => obj.order_code);
         }
   },
    specimenPreparation() {
      if (
        this.getSingleEMROrder &&
        this.caseInformationFormData.sample_types &&
        this.caseInformationFormData.case_types &&
        this.caseInformationFormData.case_types.length > 1
      ) {
        const selectedSpecimen =
          this.caseInformationFormData.sample_types.filter(
            (caseObj) => caseObj.case_type === this.accessionCaseType[0]
          );
        this.specimenTypes = selectedSpecimen;
      }
    },
    prepareEmrUpdateDetails() {
      let patientFormInfo = this.$refs["patientInformationForm"];
      return {
        case_types: this.accessionCaseType.length
          ? this.accessionCaseType
          : this.caseInformationFormData.case_types,
        collection_date: this.convertToLabUTC(
          this.caseInformationFormData.collection_date
        ),
        received_date: this.convertToLabUTC(
          this.caseInformationFormData.received_date
        ),
        hospital: this.caseInformationFormData.hospital,
        icd_10_codes: this.caseInformationFormData.icd_10_codesForm
          .filter((e) => e.value)
          .map((e) => e.value),
        ordering_physician: this.caseInformationFormData.ordering_physician,
        hospital_branch: this.caseInformationFormData.hospital_branch
          ? this.caseInformationFormData.hospital_branch
          : null,
          is_stat:this.caseInformationFormData.is_stat,
        billing_type: this.caseInformationFormData.billing_type,
        patient_info: patientFormInfo.formatPatientInfo(),
        sample_types: this.specimenTypes.length
          ? this.convertSampleTypesToCapital(this.specimenTypes)
          : this.convertSampleTypesToCapital(
            this.caseInformationFormData.sample_types
          ),
      };
    },
    convertSampleTypesToCapital(sampleTypes) {
      if (!sampleTypes) return "";
      return sampleTypes.map((s) => {
        s.sample_types = s.sample_types.map((f) => this.changetocaptila(f));
        return s;
      });
    },
    parseInsuranceForm(insuranceData) {
      let params = { ...insuranceData };

      // filtering the object
      // removing non entered values
      Object.keys(params).forEach((keyValue) => {
        if (!params[keyValue]) {
          delete params[keyValue];
        }
      });

      return params;
    },
    async sumbmitPatientDetails() {
      if (this.patientInformation) {
        this.$refs["patientInformationForm"];
      }
      let params = this.prepareEmrUpdateDetails();
      let insurance = {};

      let primaryInsuranceFormDetails = this.$refs["primaryInsuranceForm"];
      if (primaryInsuranceFormDetails) {
        let primaryInsuranceFormData = this.parseInsuranceForm(
          primaryInsuranceFormDetails.getPrimaryInsuranceFormData()
        );

        if (Object.keys(primaryInsuranceFormData).length) {
          insurance.primary_insurance = primaryInsuranceFormData;
        }
      } else {
        if (this.primaryInsuranceForm) {
          if (Object.keys(this.primaryInsuranceForm).length) {
            insurance.primary_insurance = this.primaryInsuranceForm;
          }
        }
      }

      let secondaryInsuranceFormDetails = this.$refs["secondaryInsuranceForm"];
      if (secondaryInsuranceFormDetails) {
        let secondaryInsuranceFormData = this.parseInsuranceForm(
          secondaryInsuranceFormDetails.getSecondaryInsuranceFormData()
        );

        if (Object.keys(secondaryInsuranceFormData).length) {
          insurance.secondary_insurance = secondaryInsuranceFormData;
        }
      } else if (this.secondaryInsuranceForm) {
        if (Object.keys(this.secondaryInsuranceForm).length) {
          insurance.secondary_insurance = this.secondaryInsuranceForm;
        }
      }

      let tertiaryInsuranceFormDetails = this.$refs["tertiaryInsuranceForm"];
      if (tertiaryInsuranceFormDetails) {
        let tertiaryInsuranceFormData = this.parseInsuranceForm(
          tertiaryInsuranceFormDetails.getTertiaryInsuranceFormData()
        );

        if (Object.keys(tertiaryInsuranceFormData).length) {
          insurance.tertiary_insurance = tertiaryInsuranceFormData;
        }
      } else if (this.tertiaryInsuranceForm) {
        if (Object.keys(this.tertiaryInsuranceForm).length) {
          insurance.tertiary_insurance = this.tertiaryInsuranceForm;
        }
      }

      let guarantorInsuranceFormDetails = this.$refs["guarantorInsuranceForm"];
      if (guarantorInsuranceFormDetails) {
        let guarantorInsuranceFormData = this.parseInsuranceForm(
          guarantorInsuranceFormDetails.getGuarantorInsuranceFormData()
        );

        if (Object.keys(guarantorInsuranceFormData).length) {
          insurance.guarantor = guarantorInsuranceFormData;
        }
      } else if (this.guarantorInsuranceForm) {
        if (Object.keys(this.guarantorInsuranceForm).length) {
          insurance.guarantor = this.guarantorInsuranceForm;
        }
      }
      if (
        Object.keys(insurance).length > 0 &&
        this.caseInformationFormData.billing_type == "INSURANCE"
      ) {
        params.billing_info = { insurance: insurance };
      } else {
        params.billing_info = {};
      }
      // delete params.sample_types;
      if (this.getSingleEMRTestInfo && this.getSingleEMRTestInfo.test_ids) {
        params.tests_info = this.getSingleEMRTestInfo.test_ids;
      }



      if (
        this.getSingleEMRTestInfo &&
        this.getSingleEMRTestInfo.coriell_test_panels &&
        this.getSingleEMRTestInfo.coriell_test_panels.length
      ) {
        params.coriell_test_panels =
          this.getSingleEMRTestInfo.coriell_test_panels;
      }
      this.disablePatientInformation = true;
      if (this.orderId) {
        this.updateCase = true;
        this.addUpdateSpecimenCaseTypes();
      } else {
        await this.addPatientDetails(params);
      }

      this.disablePatientInformation = false;
    },
    updateEmrOrder() {
      this.updateCase = false;
      this.askReason();
    },

    async addPatientDetails(params) {
      if (params.patient_info.email) {
        params.patient_info.email = params.patient_info.email.toLowerCase();
      }

      this.loading = true;
      await this.$store.dispatch(
        "emrOrders/validateAndSaveLocalPatient",
        params
      );
      await this.handleResponse();
      this.loading = false;
    },
    creatingAccessionDetails() {
      let params = this.prepareEmrUpdateDetails();
      if (params.patient_info.email) {
        params.patient_info.email = params.patient_info.email.toLowerCase();
      }

      params.lab = this.caseInformationFormData.lab;
      params.emr_order = this.$route.params.order_id;
      params.specimen_collector =
        this.caseInformationFormData.specimen_collector;
      if (this.getSingleEMRTestInfo && this.getSingleEMRTestInfo.test_ids) {
        params.tests_info = this.getSingleEMRTestInfo.test_ids;
      }

      if (this.getSingleEMRTestInfo && this.getSingleEMRTestInfo.emr_order_codes) {
        params.emr_order_codes = this.getSingleEMRTestInfo.emr_order_codes;
      }

      // if not groups then only we need to check panels 

      if (this.getSingleEMRTestInfo && this.getSingleEMRTestInfo.groups && this.getSingleEMRTestInfo.groups.length) {
        params.groups = [...this.getSingleEMRTestInfo.groups]
      } else if (this.getSingleEMRTestInfo && this.getSingleEMRTestInfo.panels) {
        let panels = [...this.getSingleEMRTestInfo.panels]
        params.panels = panels.map((e) => {
          return {
            "panel_id": e.panel_id,
            "test_ids": e.specific_test_ids,
            "emr_order_code": e.emr_order_code,
            "lab_order_code": e.lab_order_code
          }
        });
      }


      if (
        this.getSingleEMRTestInfo &&
        this.getSingleEMRTestInfo.coriell_test_panels &&
        this.getSingleEMRTestInfo.coriell_test_panels.length
      ) {
        params.coriell_test_panels =
          this.getSingleEMRTestInfo.coriell_test_panels;
      }
      let insurance = {};

      let primaryInsuranceFormDetails = this.$refs["primaryInsuranceForm"];
      if (primaryInsuranceFormDetails) {
        let primaryInsuranceFormData = this.parseInsuranceForm(
          primaryInsuranceFormDetails.getPrimaryInsuranceFormData()
        );

        if (Object.keys(primaryInsuranceFormData).length) {
          insurance.primary_insurance = primaryInsuranceFormData;
          if (
            insurance.primary_insurance.payor &&
            insurance.primary_insurance.payor.toLowerCase().includes("medicare")
          ) {
            if (this.checkColonyLab) {
              insurance.primary_insurance.insurance_carrier_code = "SMTX0";
            } else if (this.isDLWLab) {
              insurance.primary_insurance.insurance_carrier_code = "SMAL0";
            }
          }
        }
      } else {
        if (this.primaryInsuranceForm) {
          if (Object.keys(this.primaryInsuranceForm).length) {
            insurance.primary_insurance = this.primaryInsuranceForm;
          }
        }
      }

      let secondaryInsuranceFormDetails = this.$refs["secondaryInsuranceForm"];
      if (secondaryInsuranceFormDetails) {
        let secondaryInsuranceFormData = this.parseInsuranceForm(
          secondaryInsuranceFormDetails.getSecondaryInsuranceFormData()
        );

        if (Object.keys(secondaryInsuranceFormData).length) {
          insurance.secondary_insurance = secondaryInsuranceFormData;
        }
      } else if (this.secondaryInsuranceForm) {
        if (Object.keys(this.secondaryInsuranceForm).length) {
          insurance.secondary_insurance = this.secondaryInsuranceForm;
        }
      }

      let tertiaryInsuranceFormDetails = this.$refs["tertiaryInsuranceForm"];
      if (tertiaryInsuranceFormDetails) {
        let tertiaryInsuranceFormData = this.parseInsuranceForm(
          tertiaryInsuranceFormDetails.getTertiaryInsuranceFormData()
        );

        if (Object.keys(tertiaryInsuranceFormData).length) {
          insurance.tertiary_insurance = tertiaryInsuranceFormData;
        }
      } else if (this.tertiaryInsuranceForm) {
        if (Object.keys(this.tertiaryInsuranceForm).length) {
          insurance.tertiary_insurance = this.tertiaryInsuranceForm;
        }
      }

      let guarantorInsuranceFormDetails = this.$refs["guarantorInsuranceForm"];
      if (guarantorInsuranceFormDetails) {
        let guarantorInsuranceFormData = this.parseInsuranceForm(
          guarantorInsuranceFormDetails.getGuarantorInsuranceFormData()
        );

        if (Object.keys(guarantorInsuranceFormData).length) {
          insurance.guarantor = guarantorInsuranceFormData;
        }
      } else if (this.guarantorInsuranceForm) {
        if (Object.keys(this.guarantorInsuranceForm).length) {
          insurance.guarantor = this.guarantorInsuranceForm;
        }
      }
      if (
        Object.keys(insurance).length > 0 &&
        this.caseInformationFormData.billing_type == "INSURANCE"
      ) {
        params.billing_info = { insurance: insurance };
      } else {
        params.billing_info = {};
      }
      params.billing_acknowledged = true;
      params.medication = ["NOT AVAILABLE"];
      params.is_stat = this.caseInformationFormData.is_stat
      if(this.accessionCaseType.includes('CLINICAL_CHEMISTRY') && this.selectedOrderCodesData.length == 0) {
        params.test_codes = this.orderCodes.filter(e => e.is_completed !== true ).map(e => e.order_code);
      }
      else {
        params.test_codes = this.selectedOrderCodesData || [];
      }
      return params;
    },
    async approveCase(response) {
      this.errorDiloag = response;
      await this.$store.commit("errors/clear");
      this.loading = true;
      let params = this.creatingAccessionDetails();
      params.auto_approved = true;
      await this.$store.dispatch("emrOrders/createAccession", params);

      this.handleAccessionResponse();
      this.loading = false;
    },
    handleUpdateClose() {
      this.updateCase = false;
      this.caseInformationFormData.sample_type = "";
    },

    handlePopupClose() {
      this.multipleAccession = false;
      this.accessionCaseType = [];
      this.caseInformationFormData.sample_type = "";
    },
    async checkCaseTypesToCreateAccession() {
      this.selectedOrderCodesData=[],
      this.selectedOption = '';
      if (
        this.getSingleEMROrder &&
        this.getSingleEMROrder.case_types &&
        (this.getSingleEMROrder.case_types.length > 1 ||
          this.getSingleEMROrder.case_types.includes("CLINICAL_CHEMISTRY"))
      ) {
        this.multipleAccession = true;
        if (
          this.getSingleEMROrder &&
          this.getSingleEMROrder.case_types &&
          this.getSingleEMROrder.case_types.length &&
          this.getSingleEMROrder.case_types.includes("CLINICAL_CHEMISTRY")
        ) {
          await this.fetchEMROrderCaseTypeWise("CLINICAL_CHEMISTRY");
        }
      } else {
        this.createAccessionNumber();
      }
    },
    async createAccessionNumber() {
      try {
        this.sel
        if (this.patientInformation) {
          this.$refs["patientInformationForm"];
        }
        this.specimenPreparation();
        await this.fetchEmrTestsInfo();


        if (this.getSingleEMRTestInfo && (this.getSingleEMRTestInfo.panels || this.getSingleEMRTestInfo.groups)) {
          this.multipleAccession = false;
          const missedOrderCodes = this.getSingleEMRTestInfo.missed_emr_order_codes || [];

          if (missedOrderCodes && missedOrderCodes.length > 0) {
            try {
              await this.$confirm(
                `<p><b style="color: red;">${missedOrderCodes.join(", ")}</b> are not matched with our tests info.</p> 
                <p>Do you want to convert the case?</p>`,
                "Confirmation",
                {
                  confirmButtonText: "Proceed",
                  showCancelButton: false,
                  dangerouslyUseHTMLString: true, // 🔥 Enable HTML in message (for Element UI)
                  type: "warning",
                }
              );
              await this.accessionCreation();
            } catch (err) {
              return;
            }
          } else {
            await this.accessionCreation();
          }
        } else {
          errorNotification(this.getError || "Unable to Fetch Test Information");
        }
      } catch (error) {
        console.log(error);
        this.multipleAccession = true;
      }
    },
    async accessionCreation() {
      try {
        let params = this.creatingAccessionDetails();

        this.loading = true;
        await this.$store.dispatch("emrOrders/createAccession", params);
        this.handleAccessionResponse();
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.multipleAccession = true;
      }
    },
    async caseFormView() {
      const loading = startLoading();

      this.patientInfo = this.getSingleEMROrder.patient_info;
      this.caseForm = true;
      this.setCaseInformationData();

      this.showEditCaseInformation = false;
      setTimeout(() => {
        this.loadDateOfBirth = true;
        loading.close();
      }, 1000);
      this.loadDateOfBirth = false;
    },

    async askReason() {
      this.takeReasonDialog = true;
    },
    handleInsuranceClose() {
      this.insurancePopup = false;
      this.caseDetailsView();
      window.location.reload();
    },
    cancelNewCase() {
      this.$router.push({
        name: "ActiveEMROrders",
        query: {
          ...this.$route.query,
          redirectRoute: this.$route.name,
        },
      });
    },
    async handleAccessionResponse() {
      if (this.getOrderUpdateStatus) {
        successNotification(
          this.orderId
            ? "Accession id created successfully"
            : "Accession id created successfully"
        );
        await this.caseDetailsView();
        window.location.reload();
      } else if (this.getCaseCreationValidationErrorsCode) {
        if (
          this.getCaseCreationValidationErrorsCode.error_code ===
          "GENETIC_TEST_EXISTED" ||
          this.getCaseCreationValidationErrorsCode.error_code ===
          "TEST_ALREADY_EXISTED" ||
          this.getCaseCreationValidationErrorsCode.error_code ===
          "DUPLICATE_EXISTED" ||
          this.getCaseCreationValidationErrorsCode.error_code ===
          "NON_GENTIC_TEST_VALIDATE"
        ) {
          this.multipleAccession = false;
          this.errorDiloag = true;
          if (
            this.getCaseCreationValidationErrorsCode.errors &&
            this.getCaseCreationValidationErrorsCode.errors.existed_details
          )
            this.existingCaseData = this.creatingAccessionDetails();
          this.existedCaseDetails =
            this.getCaseCreationValidationErrorsCode.errors.existed_details;
        } else if (
          this.getCaseCreationValidationErrorsCode.error_code ==
          "PENDING_CASE_EXISTED"
        ) {
          this.multipleAccession = false;
        } else if (
          this.getCaseCreationValidationErrorsCode.errors &&
          this.getCaseCreationValidationErrorsCode.errors.details &&
          this.getCaseCreationValidationErrorsCode.errors.details.length
        ) {
          const desiredKey = "sample_types"; // The key you want to check for

          const keyExists =
            this.getCaseCreationValidationErrorsCode.errors.details.find(
              (obj) => obj.key === desiredKey
            );
          if (keyExists) {
            this.multipleAccession = true;
          } else {
            this.multipleAccession = false;
          }
        }
      } else {
        if (!this.getCaseCreationValidationErrors) {
          this.multipleAccession = false;
          errorNotification("Error while creating accession id");
        }
      }
    },
    async caseInfo() {
      this.getPatientInformation();
      this.caseForm = false;
      this.showEditCaseInformation = true;
    },
    scrollToFirstError() {
      let el = this.$el.getElementsByClassName("err")[0];

      if (el) {
        el.scrollIntoView({ block: "center" });
      }
    },
    async handleResponse() {
      if (this.getOrderUpdateStatus) {
        successNotification(
          this.orderId
            ? "Order information updated successfully"
            : "Order information saved successfully"
        );
        window.location.reload();
        await this.caseDetailsView();
      } else if (
        this.getCaseCreationValidationErrorsCode.error_code ===
        "GENETIC_TEST_EXISTED" ||
        this.getCaseCreationValidationErrorsCode.error_code ===
        "TEST_ALREADY_EXISTED" ||
        this.getCaseCreationValidationErrorsCode.error_code ===
        "DUPLICATE_EXISTED" ||
        this.getCaseCreationValidationErrorsCode.error_code ===
        "NON_GENTIC_TEST_VALIDATE"
      ) {
        if (
          this.getCaseCreationValidationErrorsCode.errors &&
          this.getCaseCreationValidationErrorsCode.errors.existed_details
        )
          this.existedCaseDetails =
            this.getCaseCreationValidationErrorsCode.errors.existed_details;
      } else if (
        this.getCaseCreationValidationErrorsCode.errors &&
        this.getCaseCreationValidationErrorsCode.errors.details &&
        this.getCaseCreationValidationErrorsCode.errors.details.length
      ) {
        const desiredKey = "sample_types"; // The key you want to check for

        const keyExists =
          this.getCaseCreationValidationErrorsCode.errors.details.find(
            (obj) => obj.key === desiredKey
          );
        if (keyExists) {
          this.updateCase = true;
        } else {
          this.updateCase = false;
        }
      } else if (this.getCaseCreationValidationErrors) {
        this.scrollToFirstError();
      } else {
        if (!this.getCaseCreationValidationErrors) {
          errorNotification("Error while updating patient information details");
        }
      }
    },

    async updatePatient(reason) {
      let params = this.prepareEmrUpdateDetails();
      let insurance = {};

      let primaryInsuranceFormDetails = this.$refs["primaryInsuranceForm"];
      if (primaryInsuranceFormDetails) {
        let primaryInsuranceFormData = this.parseInsuranceForm(
          primaryInsuranceFormDetails.getPrimaryInsuranceFormData()
        );

        if (Object.keys(primaryInsuranceFormData).length) {
          insurance.primary_insurance = primaryInsuranceFormData;
        }
      } else {
        if (this.primaryInsuranceForm) {
          if (Object.keys(this.primaryInsuranceForm).length) {
            insurance.primary_insurance = this.primaryInsuranceForm;
          }
        }
      }

      let secondaryInsuranceFormDetails = this.$refs["secondaryInsuranceForm"];
      if (secondaryInsuranceFormDetails) {
        let secondaryInsuranceFormData = this.parseInsuranceForm(
          secondaryInsuranceFormDetails.getSecondaryInsuranceFormData()
        );

        if (Object.keys(secondaryInsuranceFormData).length) {
          insurance.secondary_insurance = secondaryInsuranceFormData;
        }
      } else if (this.secondaryInsuranceForm) {
        if (Object.keys(this.secondaryInsuranceForm).length) {
          insurance.secondary_insurance = this.secondaryInsuranceForm;
        }
      }

      let tertiaryInsuranceFormDetails = this.$refs["tertiaryInsuranceForm"];
      if (tertiaryInsuranceFormDetails) {
        let tertiaryInsuranceFormData = this.parseInsuranceForm(
          tertiaryInsuranceFormDetails.getTertiaryInsuranceFormData()
        );

        if (Object.keys(tertiaryInsuranceFormData).length) {
          insurance.tertiary_insurance = tertiaryInsuranceFormData;
        }
      } else if (this.tertiaryInsuranceForm) {
        if (Object.keys(this.tertiaryInsuranceForm).length) {
          insurance.tertiary_insurance = this.tertiaryInsuranceForm;
        }
      }

      let guarantorInsuranceFormDetails = this.$refs["guarantorInsuranceForm"];
      if (guarantorInsuranceFormDetails) {
        let guarantorInsuranceFormData = this.parseInsuranceForm(
          guarantorInsuranceFormDetails.getGuarantorInsuranceFormData()
        );

        if (Object.keys(guarantorInsuranceFormData).length) {
          insurance.guarantor = guarantorInsuranceFormData;
        }
      } else if (this.guarantorInsuranceForm) {
        if (Object.keys(this.guarantorInsuranceForm).length) {
          insurance.guarantor = this.guarantorInsuranceForm;
        }
      }
      if (
        Object.keys(insurance).length > 0 &&
        this.caseInformationFormData.billing_type == "INSURANCE"
      ) {
        params.billing_info = { insurance: insurance };
      } else {
        params.billing_info = {};
      }
      if (params.patient_info.email) {
        params.patient_info.email = params.patient_info.email.toLowerCase();
      }
      if (this.getSingleEMRTestInfo && this.getSingleEMRTestInfo.test_ids) {
        params.tests_info = this.getSingleEMRTestInfo.test_ids;
      }

      if (
        this.getSingleEMRTestInfo &&
        this.getSingleEMRTestInfo.coriell_test_panels &&
        this.getSingleEMRTestInfo.coriell_test_panels.length
      ) {
        params.coriell_test_panels =
          this.getSingleEMRTestInfo.coriell_test_panels;
      }
      params.reason = reason;
      params.order_id = this.orderId;
      // delete params.sample_types;
      this.loading = true;
      await this.$store.dispatch("emrOrders/updateEmrOrder", params);
      this.loading = false;
      this.handleResponse();
    },
    async checkCaseInformation() {
      if (this.getSingleEMROrder && this.getSingleEMROrder.patient_info) {
        this.patientInformation = this.getSingleEMROrder.patient_info;

        if (this.getSingleEMROrder.patient_info._id) {
          await this.$store.dispatch(
            "patients/fetchSinglePatient",
            this.getSingleEMROrder.patient_info._id
          );
        }
      }
    },
    async setCaseInformationData() {
      if (this.getSingleEMROrder && this.getSingleEMROrder.patient_info) {
        this.patientInformation = {
          ...this.getSingleEMROrder.patient_info,
        };
      }
      if (this.getSingleEMROrder && this.getSingleEMROrder.case_types) {
        this.caseInformationFormData.case_types =
          this.getSingleEMROrder.case_types;
      }
      if (this.getSingleEMROrder && this.getSingleEMROrder.is_stat) {
        this.caseInformationFormData.is_stat = true  
      }
      if (
        this.getSingleEMROrder &&
        this.getSingleEMROrder.case_types &&
        this.getSingleEMROrder.case_types.length == 1
      ) {
        this.accessionCaseType = this.getSingleEMROrder.case_types;
        this.addSpecimenCaseTypes();
      }

      if (this.getSingleEMROrder && this.getSingleEMROrder.collection_date) {
        this.caseInformationFormData.collection_date =
          this.convertLabUTCToClient(this.getSingleEMROrder.collection_date);
      }

      if (this.getSingleEMROrder && this.getSingleEMROrder.received_date) {
        this.caseInformationFormData.received_date = this.convertLabUTCToClient(
          this.getSingleEMROrder.received_date
        );
      }

      this.caseInformationFormData.hospital =
        this.getSingleEMROrder && this.getSingleEMROrder.hospital
          ? this.getSingleEMROrder.hospital._id
          : null;
      this.fetchAllPhysiciansByHospital(this.caseInformationFormData.hospital);
      this.fetchAllPhysiciansByHospitalBranch(this.caseInformationFormData.hospital);
      this.caseInformationFormData.hospital_branch =
        this.getSingleEMROrder && this.getSingleEMROrder.hospital_branch
          ? this.getSingleEMROrder.hospital_branch._id
          : null;
      this.caseInformationFormData.ordering_physician =
        (this.getSingleEMROrder &&
          this.getSingleEMROrder.ordering_physician &&
          this.getSingleEMROrder.ordering_physician._id) ||
        null;
      this.caseInformationFormData.icd_10_codes =
        this.getSingleEMROrder && this.getSingleEMROrder.icd_10_codes
          ? this.getSingleEMROrder.icd_10_codes
          : [];
      this.caseInformationFormData.billing_type =
        this.getSingleEMROrder && this.getSingleEMROrder.billing_type
          ? this.getSingleEMROrder.billing_type
          : "";
      if (
        this.caseInformationFormData.icd_10_codes &&
        Array.isArray(this.caseInformationFormData.icd_10_codes) &&
        Array.isArray(this.caseInformationFormData.icd_10_codesForm)
      ) {
        this.caseInformationFormData.icd_10_codes.forEach((el, index) => {
          if (this.caseInformationFormData.icd_10_codesForm[index]) {
            this.caseInformationFormData.icd_10_codesForm[index].value = el;
          }
        });
      }
      if (this.getSingleEMRTestInfo && this.getSingleEMRTestInfo.test_ids) {
        this.caseInformationFormData.tests_info =
          this.getSingleEMRTestInfo.test_ids;
      }
      if (
        this.getSingleEMROrder &&
        this.getSingleEMROrder.billing_info &&
        this.getSingleEMROrder.billing_info.insurance &&
        this.getSingleEMROrder.billing_info.insurance.primary_insurance
      ) {
        this.primaryInsuranceForm = this.setInsuranceDataFromBackendData(
          this.getSingleEMROrder.billing_info.insurance.primary_insurance
        );
      }
      if (
        this.getSingleEMROrder &&
        this.getSingleEMROrder.billing_info &&
        this.getSingleEMROrder.billing_info.insurance &&
        this.getSingleEMROrder.billing_info.insurance.secondary_insurance
      ) {
        this.secondaryInsuranceForm = this.setInsuranceDataFromBackendData(
          this.getSingleEMROrder.billing_info.insurance.secondary_insurance
        );
      }
      if (
        this.getSingleEMROrder &&
        this.getSingleEMROrder.billing_info &&
        this.getSingleEMROrder.billing_info.insurance &&
        this.getSingleEMROrder.billing_info.insurance.tertiary_insurance
      ) {
        this.tertiaryInsuranceForm = this.setInsuranceDataFromBackendData(
          this.getSingleEMROrder.billing_info.insurance.tertiary_insurance
        );
      }
      if (
        this.getSingleEMROrder &&
        this.getSingleEMROrder.billing_info &&
        this.getSingleEMROrder.billing_info.insurance &&
        this.getSingleEMROrder.billing_info.insurance.guarantor
      ) {
        this.guarantorInsuranceForm =
          this.getSingleEMROrder.billing_info.insurance.guarantor;
      }
      await this.$store.dispatch("hospitals/fetchAllHospitals", {
        get_all: true,
      });
      this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
      await this.$store.dispatch("labs/fetchAllLabs", { get_all: true });
    },
    async getAutoCompletePatientsData(queryString, cb) {
      if (queryString && queryString.length > 1) {
        await this.$store.dispatch("patients/fetchAllPatients", {
          search_string: queryString,
          get_all: true,
        });
        const patientsData = [];
        (this.getAllPatients.data || []).forEach((el) => {
          patientsData.push({
            value: el.first_name + " " + el.last_name,
            ...el,
          });
        });

        cb(patientsData || []);
      } else {
        cb([]);
      }
    },
    isCategoryAvailable(category) {
      return this.orderCodes.some(
        code => code.category_code === category && !code.is_completed
      );
    },
   async isClinicalChemistry(){
    let params = {
          emr_id: this.orderId,
          case_types: ['CLINICAL_CHEMISTRY'],
        };
      await this.$store.dispatch("emrOrders/fetchEMRCaseTypesCodes", params);
        if (this.getEMRCaseTypeWiseOrderCodes) {
          this.orderCodes = this.getEMRCaseTypeWiseOrderCodes;
        }
    }
  },
};
</script>

<style lang="scss">
#patient-case-information-view {
  .case-creation__card {
    position: relative;
  }

  .case-creation__billing-information__body {
    background-color: #ffffff;
  }
}
</style>
